import React, { FC, useCallback } from 'react';

import { TestProps } from '../../internal/types/testTypes';
import { Badge } from '../Badge';
import { ClickableIcon } from '../ClickableIcon';
import { cn } from '../../lib/css/className/className';

const cls = cn('Dots');

export type Dot = {
    id: string;
};

interface Props extends TestProps {
    dot: Dot;
    index: number;
    isActive: boolean;
    onClick: (dot: Dot, index: number) => void;
}

export const Dot: FC<Props> = ({ dot, index, 'data-testid': dataTestId = 'Dot', isActive, onClick }) => {
    const handleClick = useCallback(() => {
        onClick(dot, index);
    }, [onClick, dot, index]);

    return (
        <ClickableIcon
            clickableAreaSize="8"
            key={dot.id}
            className={cls('dot')}
            onClick={handleClick}
            data-testid={dataTestId}
        >
            <Badge className={cls('dotIcon', { active: isActive })} color={isActive ? 'black' : 'gray'} size="8" />
        </ClickableIcon>
    );
};
